export default "__VITE_ASSET__COF8yN_S__"